<script lang="ts" setup>
import { onMounted } from "vue";
import { ElNotification } from "element-plus";

const capitalize = function (str: string): string {
  return str && str[0].toUpperCase() + str.slice(1);
};

// @ts-ignore
document.title = `${capitalize("Sign In")} | SmartComm`;
</script>
<template>
  <div
    class="h-[100vh] bg-gradient-to-t from-[#E8E7F5] to-[#E1F1F0] grid place-items-center font-['Lato']"
  >
    <img
      alt=""
      class="absolute w-[12rem] left-0 top-0"
      src="/images/login/side_img.png"
    />
    <div
      class="relative bg-white rounded-lg drop-shadow-lg p-20 pt-10 flex flex-col items-center"
    >
      <img
        alt=""
        class="absolute w-[12rem] right-[-10rem] bottom-[-5rem] hidden md:block"
        src="/images/login/side_img.png"
      />
      <img alt="" class="w-32" src="/images/login/logo.png" />

      <div class="grid gap-4">
        <div class="grid place-items-center text-center">
          <h2 class="text-lg font-medium text-light-purple">
            <slot name="login-title"></slot>
          </h2>
          <span class="text-xs text-gray-400 w-[17rem]">
            <slot name="login-info"></slot>
          </span>
        </div>

        <slot />
      </div>
    </div>
  </div>
</template>
<style scoped>

@media (max-width: 640px) {
  .h-[100vh] {
    background-size: cover;
    background-position: top; 
  }


  .p-20 {
    padding: 2rem; 
  }


  .absolute.w-[12rem].left-0.top-0 {
    width: 8rem; 
    left: 1rem; 
    top: 1rem; 
  }

  .absolute.w-[12rem].right-[-10rem].bottom-[-5rem] {
    width: 8rem; 
    right: -4rem; 
    bottom: -2rem; 
  }
}
</style>